import { Checkbox, SelectInput, TextInput } from "@/components/ui/Field";
import {
  ANSPRECHPARTNER_TEAM_MAIL_DOKUMENTARTEN,
  ansprechpartnerAnredeOptions,
} from "@/lib/kontakte";
import {
  toggleTeamMailDokumentart,
  type ApForm,
  type ApFormUpdater,
} from "@/pages/kontakte/ansprechpartnerFormState";

export function AnsprechpartnerFormFields({
  form,
  onChange,
}: {
  form: ApForm;
  onChange: (updater: ApFormUpdater) => void;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <SelectInput
        label="Anrede"
        value={form.anrede}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, anrede: value }));
        }}
      >
        <option value="">—</option>
        {ansprechpartnerAnredeOptions(form.anrede).map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </SelectInput>
      <TextInput
        label="Position/Funktion"
        value={form.funktion}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, funktion: value }));
        }}
      />
      <TextInput
        label="Vorname"
        value={form.vorname}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, vorname: value }));
        }}
      />
      <TextInput
        label="Nachname"
        value={form.nachname}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, nachname: value }));
        }}
      />
      <TextInput
        label="Telefon"
        value={form.telefonnummer}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, telefonnummer: value }));
        }}
      />
      <TextInput
        label="Mobiltelefon"
        value={form.mobiltelefon}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, mobiltelefon: value }));
        }}
      />
      <TextInput
        label="E-Mail"
        type="email"
        value={form.mail}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, mail: value }));
        }}
        className="sm:col-span-2"
      />
      <TextInput
        label="Team-Mail"
        type="email"
        value={form.teamMail}
        onChange={(e) => {
          const value = e.target.value;
          onChange((current) => ({ ...current, teamMail: value }));
        }}
        className="sm:col-span-2"
        hint="Zusätzliche Adresse. Dokumente, die an diese Person gehen, werden bei den angehakten Arten auch dorthin gesendet."
      />
      <fieldset className="sm:col-span-2">
        <legend className="mb-2 text-sm font-medium text-label">Auch an die Team-Mail senden</legend>
        <div className="grid gap-2 sm:grid-cols-2">
          {ANSPRECHPARTNER_TEAM_MAIL_DOKUMENTARTEN.map((art) => (
            <Checkbox
              key={art.key}
              label={art.label}
              checked={form.teamMailDokumentarten.includes(art.key)}
              onChange={() =>
                onChange((current) => ({
                  ...current,
                  teamMailDokumentarten: toggleTeamMailDokumentart(
                    current.teamMailDokumentarten,
                    art.key,
                  ),
                }))
              }
            />
          ))}
        </div>
      </fieldset>
    </div>
  );
}
